import { splitString } from "./strings";
import { IAccessPayload } from "@/@types/_shared/token-servises";
import { ServersCode } from "@/config/servers-code.config";
import store from "../store/index";
interface IServersCode {
  [key: string]: string;
}

export const AccessToken = {
  get access(): string {
    return store.getters.getAccess;
  },
  get payload(): IAccessPayload | null {
    if (!AccessToken.access) return null;
    const payload = splitString(AccessToken.access, ".")[1];
    return JSON.parse(atob(payload));
  },
  get id(): string {
    return AccessToken.payload ? AccessToken.payload.id : "";
  },
};

export function getPayload(token: string): IAccessPayload {
  const payload = splitString(token, ".")[1];
  return JSON.parse(atob(payload));
}

export function accessPermissions(server: string): boolean {
  const access = localStorage.getItem("access");
  if (access) {
    const permissions = getPayload(access).permissions;
    if (permissions.includes(server)) return true;
  }
  return false;
}

export function getPermitions(): string[] {
  let token = localStorage.getItem("access");
  if (!token) token = store.getters.getAccess;
  if (!token) return [];

  const payload = getPayload(token);
  return payload.permissions;
}

export function getRootPermition(): boolean {
  return store.getters.getUserRole == "root" ? true : false;
}

export function getAdminPermition(): boolean {
  return store.getters.getUserRole == "admin" ? true : false;
}

export function getRight(requestCode: string): boolean {
  if (getRootPermition()) return true;
  const codeKeys = Object.keys(ServersCode);
  if (codeKeys.includes(requestCode)) {
    const code: IServersCode = ServersCode;
    return accessPermissions(code[requestCode]);
  }
  return false;
}
